import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Auth } from '../../service/auth';

@Component({
	selector: 'app-teacher-assign-test-result',
	templateUrl: './teacher-assign-test-result.component.html',
	styleUrls: ['./teacher-assign-test-result.component.css']
})
export class TeacherAssignTestResultComponent implements OnInit {

	currentStudentToken;
	Result: Auth[];
	TestList: Auth[];
	searchText;

	pageRow;
	p = 1;
	arrayOfArrays = [];
	count;
	list1 = [];
	rowCount = 10;
	pageCount;
	min;
	max;
	selectedIndex: number;

	constructor(public authService: AuthService) { }

	ngOnInit() {
		this.tokenStudentRegister();
		this.getUserAddedTest();
		this.testDetails();
	}

	tokenStudentRegister() {
		this.currentStudentToken = localStorage.getItem('currentStudentToken')
	}

	getUserAddedTest() {
		const s = this.authService.getAddedTestList();
		s.snapshotChanges().subscribe(data => {
			this.TestList = [];
			this.count = 0;
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				const b = item.payload.val().userId;
				const c = item.payload.val().endTime;
				if (this.currentStudentToken === b && c) {
					this.count += 1;
					this.TestList.push(a as Auth);
				}
			});
			this.pageLoadRowCount();
		});
	}

	testDetails() {
		const s = this.authService.getQuizDetails();
		s.snapshotChanges().subscribe(data => {
			this.Result = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				// const b = item.payload.val().student_id;
				this.Result.push(a as Auth);
			});
		});
	}

	pageLoadRowCount() {
		this.p = 1;
		this.pageCount = 0;
		this.arrayOfArrays.length = 0;
		for (let i = 1; i <= this.count; i++) {
			this.list1.push(i)
		}
		while (this.list1.length > 0) {
			let arrayElement = this.list1.splice(0, this.rowCount);
			this.arrayOfArrays.push(arrayElement);
		}
		this.pageCount = this.arrayOfArrays.length;
		if (this.p === 1) {
			this.min = 1
			this.max = this.rowCount
			this.select(this.p - 1);
		}
	}

	select(index: number) {
		this.selectedIndex = index;
	}

	displayRowCount(p) {
		this.select(p - 1);
		for (let i = 0; i < this.pageCount; i++) {
			if (i + 1 === p) {
				const x = Math.min(...this.arrayOfArrays[i])
				this.min = x
				const y = Math.max(...this.arrayOfArrays[i])
				this.max = y
			}
		}
	}

}